export const FEATURE_GROUP_ALL_NAME = "All";

export const VISUALIZER_TYPES_NAMES = {
  bathroom: "bathroom",
  kitchen: "kitchen",
  fireplace: "fireplace",
  laundryroom: "laundryroom"
};
